var exports = {
  "T": "visual__OKKtN7",
};

module.exports = exports;
